import { ErrorSidePanel } from '@/components/errors';
import { useGetProfiles } from '@/hooks/api';
import { ModuleName, Screen, type SkinPageConfig, templates } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { type TvProfilesListProps } from './-model/props';
import { TvProfilesListLight, TvProfilesListWooDark, TvProfilesListWoo } from './-skins';

export const Route = createFileRoute('/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/(list)/')({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
  staticData: {
    module: ModuleName.Tv,
    screen: Screen.ProfilesList,
  },
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data: profiles, isLoadingData } = useGetProfiles(id);
  const props: TvProfilesListProps = {
    profiles: profiles ?? [],
    isLoading: isLoadingData,
    sa: id,
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: TvProfilesListProps): SkinPageConfig {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: <TvProfilesListWooDark {...props} />,
      },
      {
        selector: 'isWooTemplate',
        component: <TvProfilesListWoo {...props} />,
      },
    ],
    defaultValue: <TvProfilesListLight {...props} />,
  };
}
